import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

const freeConsultationText = css`
  margin-bottom: 8px;
`;

type GuaranteeProps = {
  onConsultationSignupBtnClick: () => void;
};

export const Guarantee = ({ onConsultationSignupBtnClick }: GuaranteeProps) => (
  <>
    <ModalHeader title="Гарантия качества" />
    <ModalContent>
      <Typography className={freeConsultationText} variant="m" size="body_long">
        Предоставим гарантию и&nbsp;на&nbsp;дверь и&nbsp;на&nbsp;установку от&nbsp;1&nbsp;года.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementText="Оставить заявку"
        elementName="Гарантия качества"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
